import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';
import { underIPhone5 } from '@westwing/ui-kit/breakPoints';
import { BellaTestIds } from '../../../../../common/qaIds';

const StyledWrapper = styled.div`
    margin-top: 20px;
    font-size: 0.8em;

    ${underIPhone5`
        margin-top: 10px;
    `}
`;

const StyledButton = styled.button`
    color: ${({ theme }) => theme.colors.turquoise100};
    padding-left: 5px;
    border: 0 none;
    background: 0 0;
    line-height: 1.25em;
    text-decoration: underline;
`;

export interface FooterPros {
    text: string;
    buttonText: string;
    handleToggleFormButtonClick: () => void;
}

const Footer: FC<FooterPros> = ({ text, buttonText, handleToggleFormButtonClick }): ReactElement => (
    <StyledWrapper>
        {text}
        <StyledButton data-testid={BellaTestIds.loginRegSwitchBtn} type="button" onClick={handleToggleFormButtonClick}>
            {buttonText}
        </StyledButton>
    </StyledWrapper>
);

export default Footer;
